import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/services/http-service.service';
import { LanguageService } from 'src/app/services/language.service';
import { GoogleMapsLoaderService } from 'src/app/services/google-maps-loader.service';

@Component({
  selector: 'app-sucursal-card-promo',
  templateUrl: './sucursal-card-promo.component.html',
  styleUrl: './sucursal-card-promo.component.scss',
})
export class SucursalCardPromoComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('map') mapElement: any;
  map: google.maps.Map | undefined;
  marker: google.maps.marker.AdvancedMarkerElement | undefined;

  html = ``;
  @Input() sucursal: any;

  private languageSub?: Subscription;
  private mapRequestId = 0;

  constructor(
    private readonly http: HttpService,
    private readonly languageService: LanguageService,
    private readonly googleMapsLoader: GoogleMapsLoaderService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.languageSub = this.languageService.currentLanguage$.subscribe(() => {
      this.loadTyc();
    });
  }

  ngAfterViewInit(): void {
    void this.setMap();
  }

  ngOnDestroy(): void {
    this.languageSub?.unsubscribe();
  }

  private loadTyc(): void {
    this.http.getTYC().subscribe((response: any) => {
      this.html = response.body;
    });
  }

  getBranchName(): string {
    return this.sucursal.branchName || this.sucursal.name;
  }

  getBranchStreet(): string {
    return this.sucursal.address?.street || '';
  }

  getBranchLatitude(): number {
    return this.sucursal.address?.latitude || 0;
  }

  getBranchLongitude(): number {
    return this.sucursal.address?.longitude || 0;
  }

  async setMap(): Promise<void> {
    const requestId = ++this.mapRequestId;
    this.cdr.detectChanges();

    const element = this.mapElement?.nativeElement as HTMLElement | undefined;
    if (!element) {
      return;
    }

    try {
      if (this.marker) {
        this.marker.map = null;
        this.marker = undefined;
      }

      const { map, marker } = await this.googleMapsLoader.createBranchMap({
        element,
        latitude: Number(this.getBranchLatitude()),
        longitude: Number(this.getBranchLongitude()),
        title: this.getBranchName(),
      });

      if (requestId !== this.mapRequestId) {
        marker.map = null;
        return;
      }

      this.map = map;
      this.marker = marker;
    } catch (error) {
      console.error('Error al inicializar el mapa de sucursal promo:', error);
    }
  }
}
